import { Injectable } from '@angular/core';
import { AuthService } from '@evc/platform';
import { filter, firstValueFrom, map, Observable, switchMap, take } from 'rxjs';
import { Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class EvcAuthService {
  public claims$ = toObservable(this.authService.idTokenClaims);
  public hasAccessToApplication$: Observable<boolean> = toObservable(this.authService.idTokenClaims).pipe(
    filter(claims => !!claims),
    map(claims => !!(claims.organizationId && claims.licenseIds))
  );
  public isAuthenticated$ = toObservable(this.authService.isAuthenticated).pipe(filter(isAuthenticated => isAuthenticated !== undefined));

  public constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  public async init(): Promise<boolean> {
    const isAuthenticated = await this.authService.init();
    return isAuthenticated;
  }

  public login(): void {
    firstValueFrom(this.authService.login());
  }

  public logout(): void {
    firstValueFrom(this.authService.logout());
    localStorage.clear();
    this.router.navigate(['/']);
  }

  public refreshTokens(): Observable<void> {
    const originalAccessToken = this.authService.accessToken();
    return this.authService.requestAccessToken().pipe(switchMap(result => result && this.authService.accessToken$.pipe(
      // HACK: We need to wait for the service to expose latest access token.
      // Otherwise, the old token might still be used in subsequent requests.
      filter(token => token && (token === result.accessToken || token !== originalAccessToken)),
      take(1),
      map(() => void 0)
    )));
  }

  public async isLoggedIn(): Promise<boolean> {
    return firstValueFrom(this.isAuthenticated$);
  }

  public getIdTokenValue(): string {
    return this.authService.accessToken();
  }


}
